//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import caReader from '@components-sys/ca-reader';

export default {
    props: [],
    components: { caReader },
    data() {
        return {
            form: {
                name: '',
                certb64: '',
            },

            stepController: 0,
        };
    },
    computed: {
        isIE() {
            return window.ActiveXObject !== undefined;
        },
    },
    methods: {
        onSubmit() {
            this.$post('/bhtong/admin/calogin.json', this.form, (data, res) => {
                ShowMsg.call(this, '登录成功', 'success');

                data.user.avatar = data.avatar || '';
                data.user.maxnum = data.maxnum || '';
                data.user.biglogo = data.biglogo || '';
                data.user.smalllogo = data.smalllogo || '';

                this.$store.commit('setLoginUserInfo', data);

                // window.location.replace(res.url);
                // this.$router.replace(res.url)
                this.$router.replace('/office/guarantee/list');
            });
        },
        doanloadCa() {
            window.open(
                'http://hebca.com/html/list_1119b6b1243646e892b194451767351f.html'
            );
        },
    },
    mounted: function () {},
};
